import {
  ApiBlueprint,
  PageBlueprint,
  createFrontendPlugin,
  type FrontendFeature,
} from '@backstage/frontend-plugin-api';
import {
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { changesApiRef } from './api/ChangesApi';
import { ChangesClient } from './api/ChangesClient';

const changesApi = ApiBlueprint.make({
  params: define =>
    define({
      api: changesApiRef,
      deps: { fetchApi: fetchApiRef, discoveryApi: discoveryApiRef },
      factory: ({ fetchApi, discoveryApi }) =>
        new ChangesClient({ fetchApi, discoveryApi }),
    }),
});

const changesListPage = PageBlueprint.make({
  params: {
    path: '/changes',
    loader: () =>
      import('./components/ChangesListPage').then(m => <m.ChangesListPage />),
  },
});

export const changesPlugin: FrontendFeature = createFrontendPlugin({
  pluginId: 'changes',
  extensions: [changesApi, changesListPage],
});

export default changesPlugin;
